(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const MINIMUM_PHOTOS = 4;
  const EXCLUDED_PRODUCT_IDS = new Set(['10798041530678', '10798042415414', '10798042448182', '10798042480950', '10798042513718', '10798042612022', '10782579327286', '10799882469686', '10798731100470', '10774698328374', '10775234642230', '10783979536694', '10797091488054', '10797091750198', '10779138392374', '10780330066230', '10798687355190', '10808390549814', '10808466407734', '10798268318006', '10836529316150']);
  const SHOP_LOOK_SELECTOR = [
    '[data-ravena-shop-look]',
    '[data-shop-the-look]',
    '[data-shop-look]',
    '.shop-the-look',
    '.shop-look'
  ].join(',');
  let scheduled = false;

  const normalizedSource = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.href);
      if (url.hostname === 'review-images.judgeme.com' || url.hostname === 'review-images.judge.me') {
        url.search = '';
      }
      return url.toString();
    } catch (_) {
      return value;
    }
  };

  const productRoot = () => document.querySelector('product-info[id^="MainProduct-"][data-product-id]');

  const collectPhotos = () => {
    const widget = document.querySelector('.jdgm-review-widget[data-product-id]');
    const productId = widget?.dataset.productId;
    const gallery = window.jdgm?.data?.reviewWidget?.[productId]?.photo_gallery || [];
    const photos = [];
    const seen = new Set();
    gallery.forEach((review) => {
      (review.pictures_urls || []).forEach((picture) => {
        const source = normalizedSource(
          picture.original || picture.huge || picture.compact || picture.small || ''
        );
        if (!source || seen.has(source)) return;
        seen.add(source);
        photos.push(source);
      });
    });
    document.querySelectorAll(
      '.jdgm-review-widget .jm-media-grid__item img, .jdgm-review-widget .jdgm-gallery__thumbnail img, .jdgm-review-widget .jdgm-rev__pic-img'
    ).forEach((image) => {
      const source = normalizedSource(image.currentSrc || image.src || '');
      if (!source || seen.has(source)) return;
      seen.add(source);
      photos.push(source);
    });
    return photos;
  };

  const findOriginalItem = (source) => {
    const normalized = normalizedSource(source).split('?')[0];
    return Array.from(document.querySelectorAll('.jdgm-review-widget .jm-media-grid__item')).find((item) => {
      const image = item.querySelector('img');
      return normalizedSource(image?.currentSrc || image?.src || '').split('?')[0] === normalized;
    });
  };

  const removeFallback = () => {
    document.querySelector('[data-sakura-mobile-photo-reviews]')?.remove();
  };

  const render = () => {
    scheduled = false;
    const root = productRoot();
    if (!window.matchMedia(MOBILE_QUERY).matches || !root || EXCLUDED_PRODUCT_IDS.has(root.dataset.productId)) {
      removeFallback();
      return;
    }
    if (document.querySelector(SHOP_LOOK_SELECTOR)) {
      removeFallback();
      return;
    }
    const photos = collectPhotos();
    if (photos.length < MINIMUM_PHOTOS) {
      removeFallback();
      return;
    }

    let section = document.querySelector('[data-sakura-mobile-photo-reviews]');
    if (!section) {
      section = document.createElement('section');
      section.className = 'sakura-mobile-photo-reviews';
      section.dataset.sakuraMobilePhotoReviews = 'true';
      section.setAttribute('aria-label', 'Customer photo reviews');
      section.innerHTML =
        '<h2 class="sakura-mobile-photo-reviews__heading">Customer Photos</h2>' +
        '<div class="sakura-mobile-photo-reviews__track" role="list"></div>' +
        '<div class="sakura-mobile-photo-reviews__progress" aria-hidden="true">' +
        '<span class="sakura-mobile-photo-reviews__progress-thumb"></span></div>';
      const root = productRoot();
      const trust = root.querySelector('[data-sakura-trust-panel]');
      const form = root.querySelector('product-form.product-form, product-form');
      if (trust) trust.insertAdjacentElement('beforebegin', section);
      else if (form) form.insertAdjacentElement('afterend', section);
      else return;
    }

    const track = section.querySelector('.sakura-mobile-photo-reviews__track');
    const progress = section.querySelector('.sakura-mobile-photo-reviews__progress');
    const progressThumb = section.querySelector('.sakura-mobile-photo-reviews__progress-thumb');
    const signature = photos.join('|');
    if (track.dataset.signature === signature) return;
    track.dataset.signature = signature;
    track.innerHTML = '';
    photos.forEach((source, index) => {
      const button = document.createElement('button');
      button.className = 'sakura-mobile-photo-reviews__item';
      button.type = 'button';
      button.setAttribute('role', 'listitem');
      button.setAttribute('aria-label', 'Open customer photo ' + (index + 1));
      button.innerHTML = '<img alt="Customer photo review ' + (index + 1) + '" loading="lazy" decoding="async">';
      button.querySelector('img').src = source;
      button.addEventListener('click', () => {
        const original = findOriginalItem(source);
        if (original) {
          original.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          return;
        }
        document.querySelector('.jdgm-review-widget')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      track.appendChild(button);
    });
    const updateProgress = () => {
      const hasOverflow = photos.length > 4 && track.scrollWidth > track.clientWidth + 1;
      progress.classList.toggle('is-visible', hasOverflow);
      if (!hasOverflow) {
        progressThumb.style.removeProperty('width');
        progressThumb.style.removeProperty('transform');
        return;
      }
      const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
      const thumbWidth = Math.max(18, visibleRatio * progress.clientWidth);
      const maxScroll = Math.max(1, track.scrollWidth - track.clientWidth);
      const maxTravel = Math.max(0, progress.clientWidth - thumbWidth);
      const travel = Math.min(maxTravel, Math.max(0, track.scrollLeft / maxScroll * maxTravel));
      progressThumb.style.width = thumbWidth + 'px';
      progressThumb.style.transform = 'translateX(' + travel + 'px)';
    };
    if (track.dataset.sakuraProgressBound !== 'true') {
      track.dataset.sakuraProgressBound = 'true';
      track.addEventListener('scroll', () => window.requestAnimationFrame(updateProgress), { passive: true });
    }
    window.requestAnimationFrame(updateProgress);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(render);
  };

  const start = () => {
    render();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    setTimeout(schedule, 500);
    setTimeout(schedule, 1500);
    setTimeout(schedule, 3500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();